const accordionContainer = {};

accordionContainer.generic = () => {

    let itemContainerOpen = "accordion-container__item-open";
    let $accordionContainerTitles = document.querySelectorAll(".js-accordion-container-title");

    for (let i=0;i<$accordionContainerTitles.length;i++) {
        $accordionContainerTitles[i].addEventListener("click",toggleItem,false);
    }

    function toggleItem(e){
        let $itemOpen = document.querySelector("."+itemContainerOpen);
        let sameElem = false;
        if ($itemOpen){
            closeItem($itemOpen);
            sameElem = $itemOpen.querySelector(".js-accordion-container-title") === e.target;
        }
        if (!sameElem){
            let panel = e.target.parentNode;
            openItem(panel);
        }
    }

    function closeItem($itemOpen){
        let panelCopy = $itemOpen.querySelector(".accordion-container__list");
        $itemOpen.classList.remove(itemContainerOpen);
        panelCopy.style.removeProperty("opacity");
        panelCopy.style.removeProperty("display");
    }

    function openItem(panel){
        let panelCopy = panel.querySelector(".accordion-container__list");
        panel.classList.add(itemContainerOpen);
        panelCopy.style.opacity = '1';
        panelCopy.style.display = 'block';
    }

}

accordionContainer.init = () => {
    accordionContainer.generic();
}

export default accordionContainer;
